import React, { useState, useCallback, useEffect } from 'react';

import { isUndefined, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function InputTransparent({ row, name, onSubmit }) {
  const [data, setData] = useState(null);
  const [edited, setEdited] = useState(false);
  const [loading, setLoading] = useState(false);

  // change value input
  const handleChangeInput = useCallback(({ target }) => {
    setData(target.value);
    setEdited(true);
  }, []);

  // submit value
  const handleOnSubmit = useCallback(async (value) => {
    const sendObject = { ...row, [name]: value };

    setLoading(true);

    try {
      await onSubmit(sendObject);
      setEdited(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  // key press in input
  const handleKeyPress = useCallback((e) => {
    const { key, target } = e;
    if (key === 'Enter') handleOnSubmit(target.value);
  }, []);

  // onBlur input
  const handleOnBlurInput = useCallback(
    ({ target }) => {
      if (edited) handleOnSubmit(target.value);
    },
    [data, edited]
  );

  // change value in render row
  useEffect(() => {
    const searchValue = row[name];

    if (!isEmpty(searchValue) && !isUndefined(searchValue))
      setData(searchValue);
  }, [row]);

  return (
    <S.Wrapper
      value={data}
      onChange={handleChangeInput}
      onKeyPress={handleKeyPress}
      onBlur={handleOnBlurInput}
      disabled={loading}
    />
  );
}

InputTransparent.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  name: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
